import type { NavigateFunction } from "react-router";

// Bridge for the couple of call sites that need to navigate imperatively
// from outside any component's hook scope (a websocket event handler, a
// plain helper function). <AppNavigateBridge> (./app-navigate.tsx) stashes
// the current `navigate` function here via setCurrentNavigate(), and
// appNavigate() reads it back.
//
// Deliberately bypasses the navigation-guard registry
// (./navigation-guard.tsx) - both current callers (a forced logout on
// account ban, an in-place query-param cleanup) are internal/forced
// transitions, not discretionary user navigation, so neither should ever
// be interruptible by an "unsaved changes" prompt.
let currentNavigate: NavigateFunction | null = null;

export function setCurrentNavigate(navigate: NavigateFunction | null) {
  currentNavigate = navigate;
}

export function appNavigate(to: string, options?: { replace?: boolean }) {
  if (!currentNavigate) {
    // Should never happen in practice - <AppNavigateBridge> mounts at the
    // app root before any event handler that could call this fires. Not
    // throwing here (unlike useNavigationGuard()) since this runs from
    // places like a websocket message handler, where surfacing a thrown
    // error is worse than a logged one and a no-op.
    console.error("appNavigate() called before AppNavigateBridge mounted");
    return;
  }
  void currentNavigate(to, options);
}
